import React, { useState, useEffect, useRef } from "react";

import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

import DataTable from "@app/components/datatable/DataTable";

import { InputGroup } from "react-bootstrap";

import axios from '@app/lib/axios';

const ModalSearch = ({
  show,
  setShow,
  selected,
  locCodes,
  onSearchSelected,
}) => {
  const searchInputRef = useRef();
  const dataTableRef = useRef();
  const [list, setList] = useState([]);
  const [onSearching, setOnSearching] = useState(false);

  let locCodeParent =
    selected && selected.locCode
      ? Math.floor(selected.locCode / 1000)
      : locCodes[0].code;
  // 제주도 어린이집 예외
  if(locCodeParent === 49) {
    locCodeParent = 50;
  }
  const locParent = locCodes.find((l) => l.code === locCodeParent);
  const locCodeChild =
    selected && selected.locCode
      ? locParent.child.find((l) => (l.code === selected.locCode || l.code_daycare === selected.locCode))
      : locCodes[0].child[0];

  const [sidoList] = useState(locCodes);
  const [sigunguList, setSigunguList] = useState(
    locCodes ? locParent.child : []
  );
  const [searchParam, setSearchParam] = useState({
    sido: locCodeParent,
    sigungu: locCodeChild.code,
    type: "SA",
    name: selected.name,
  });

  useEffect(() => {
    dataTableRef.current.refreshDataTable(true);
    return () => {};
  }, [show, locCodes, list]);

  const tableSetting = {
    processing: false,
    serverSide: false,
    searching: false,
    paging: false,
    ordering: false,
    select: "single",
    scrollX: true,
    scrollY: "350px",
    scrollCollapse: true,
    sort: false,
    lengthMenu: [
      [20, 50, 100],
      [20, 50, 100],
    ],
    columns: [
      { title: "ID", data: "no" },
      { title: "원명", data: "name" },
      { title: "원장", data: "director" },
      { title: "전화", data: "tel" },
      { title: "주소", data: "address" },
      { title: "계약", data: "contractAp" },
      { title: "운영", data: "status" },
      { title: "통합 원", data: "uniqId" },
      { title: "비고", data: "apiKey" },
    ],
    columnDefs: [
      // {
      //     targets: [0],
      //     visible: false
      // },
      {
        targets: [0, 1, 2, 3, 4, 5, 6, 7, 8],
        className: "dt-center text-nowrap",
      },
      {
        targets: [2, 6],
        render: (data, type, row) => {
          return data ? data : "-";
        },
      },
      {
        targets: [5],
        render: (data, type, row) => {
          return data
            ? data == "폐지"
              ? `<span class="text-danger">${data}</span>`
              : data
            : "-";
        },
      },
      {
        targets: 7,
        className: "dt-center",
        render: (data, type, row) => {
          return data !== null
            ? `<span class="text-success">등록됨</span>`
            : `<span class="text-primary">신규</span>`;
        },
      },
      {
        targets: 8,
        className: "dt-center",
        render: (data, type, row) => {
          if (selected.uniqId && selected.uniqId == row.uniqId) {
            return `<button type="button" class="update-item btn btn-sm btn-secondary">연동됨</button>`;
          } else {
            return `<button type="button" class="update-item btn btn-sm btn-primary" onClick="dataCallback('${data}')">선택</button>`;
          }
        },
      },
    ],
  };

  const onChangeSido = (value) => {
    if (locCodes) {
      const param = { ...searchParam };
      param.sido = value;
      const sido = locCodes.filter((sido) => {
        return "" + sido.code === value;
      });
      if (sido && sido.length >= 1) {
        setSigunguList(sido[0].child);
        param.sigungu = sido[0].child[0].code;
      }
      setSearchParam(param);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      searchNursery();
    }
  };

  const searchNursery = () => {
    if (!searchParam.type) {
      alert("원 타입이 선택되지 않았습니다.");
      return;
    }

    if (!searchParam.sido) {
      alert("지역(시/도, 시/군/구)은 필수로 선택해 주세요.");
      return;
    }

    if (!searchParam.sigungu) {
      alert("지역(시/도, 시/군/구)은 필수로 선택해 주세요.");
      return;
    }
    setOnSearching(true);
    axios({
      method: "GET",
      url: `/api/nursery_api/refine/search/${searchParam.type}?siDo=${searchParam.sido}&siGunGu=${searchParam.sigungu}&name=${searchParam.name}`,
      // url: `/api/nursery_api/${searchParam.type}?siDo=${searchParam.sido}&siGunGu=${searchParam.sigungu}&name=${searchParam.name}`
    })
      .then((res) => {
        const result = res.data.list;
        setList(result);
        setOnSearching(false);
        if (searchInputRef && searchInputRef.current) {
          searchInputRef.current.focus();
        }
      })
      .catch((error) => {
        console.log(error);
        setOnSearching(false);
        alert(
          "알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요."
        );
      });
  };

  window.dataCallback = (apiKey) => {
    const data = list.filter((n) => {
      return n.apiKey === apiKey;
    });

    if (onSearchSelected) {
      const _data = data[0];
      _data.sido = searchParam.sido;
      _data.sigungu = searchParam.sigungu;
      onSearchSelected(_data);
      setShow(false);
    } else {
      console.log(data[0]);
    }
  };

  return (
    <>
      <Modal
        size="xl"
        show={show}
        onHide={() => setShow(false)}
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header className="mb-0" closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            유치원 어린이집 통합 DB 조회
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-3">
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">원</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  value={selected.name}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="col-6">
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">주소</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  value={selected.address}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="col-3">
              <div class="input-group input-group-sm mb-3">
                <div class="input-group-prepend">
                  <span class="input-group-text">전화</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  value={selected.tel}
                  readOnly={true}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-1 mb-2">
              <label htmlFor="edit_nursery">시/도</label>
              <select
                className="form-control mt-2"
                onChange={(e) => onChangeSido(e.target.value)}
                value={searchParam.sido}
                disabled={onSearching}
              >
                {sidoList &&
                  sidoList.map((sido) => {
                    return <option value={sido.code}>{sido.name}</option>;
                  })}
              </select>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pt-1 mb-2">
              <label htmlFor="edit_nursery">시/군/구</label>
              <select
                className="form-control mt-2"
                value={searchParam.sigungu}
                disabled={onSearching}
                onChange={(e) => {
                  const param = { ...searchParam };
                  param.sigungu = e.target.value;
                  setSearchParam(param);
                }}
              >
                {sigunguList &&
                  sigunguList.map((sigungu) => {
                    return <option value={sigungu.code}>{sigungu.name}</option>;
                  })}
              </select>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <div>
                <label className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    name="type"
                    value="SA"
                    className="custom-control-input"
                    checked={searchParam.type === "SA"}
                    disabled={onSearching}
                    onChange={(e) => {
                      const param = { ...searchParam };
                      param.type = e.target.value;
                      setSearchParam(param);
                    }}
                  />
                  <span className="custom-control-label">전체</span>
                </label>
                <label className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    name="type"
                    value="S"
                    className="custom-control-input"
                    checked={searchParam.type === "S"}
                    disabled={onSearching}
                    onChange={(e) => {
                      const param = { ...searchParam };
                      param.type = e.target.value;
                      setSearchParam(param);
                    }}
                  />
                  <span className="custom-control-label">유치원</span>
                </label>
                <label className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    name="type"
                    value="A"
                    checked={searchParam.type === "A"}
                    className="custom-control-input"
                    disabled={onSearching}
                    onChange={(e) => {
                      const param = { ...searchParam };
                      param.type = e.target.value;
                      setSearchParam(param);
                    }}
                  />
                  <span className="custom-control-label">어린이집</span>
                </label>
              </div>
              <InputGroup className="input-group my-group">
                <input
                  className="form-control"
                  type="text"
                  value={searchParam.name}
                  disabled={onSearching}
                  onChange={(e) => {
                    const param = { ...searchParam };
                    param.name = e.target.value;
                    setSearchParam(param);
                  }}
                  onKeyPress={handleKeyPress}
                  ref={searchInputRef}
                />
                <InputGroup.Append>
                  <button
                    className="btn btn-primary"
                    onClick={searchNursery}
                    disabled={onSearching}
                  >
                    {onSearching ? <i class="fas fa-spinner"></i> : "검색"}
                  </button>
                </InputGroup.Append>
              </InputGroup>
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12">
              <span className="h5">
                조회 결과 : 총 {list ? list.length : 0}건
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12 small">
              <span className="">* 필드 설명</span>
              <br />
              <span className="ml-3">
                <span className="">
                  - 운영 > 유치원의 경우 공공 API에서 운영 상태 정보를 제공하지
                  않는 점 참고해 주시기 바랍니다.
                </span>
              </span>
              <br />
              <span className="ml-3">
                <span className="">
                  - 통합 원 ><span className="text-primary">신규</span>: TAS에 처음
                  등록되는 원 / <span className="text-success">등록됨</span>: 통합 원 DB에 등록되어 있는 원
                </span>
              </span>
              <br />
            </div>
            <div
              className="col-xl-12 col-lg-12 col-md-8 col-sm-12 col-12 ag-theme-alpine"
              style={{ height: `400px` }}
            >
              <DataTable
                tableID="nuseryAPISearch"
                className="display compact cell-border nowrap"
                data={list}
                ref={dataTableRef}
                {...tableSetting}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalSearch;
